import { useEffect } from 'react';
import { useForm } from 'react-final-form';

export const useHighlightingErrorGender = () => {
    const form = useForm();
    const { errors } = form.getState();

    useEffect(() => {
        if (errors?.gender && Object.keys(errors).length === 1) {
            form.blur('gender');
        }
    }, [errors, form]);
};
